<template>
    <div class="c-default-overlay is-active">
        <button class="close-button c-overlay-close-button" aria-label="Close alert" type="button" v-on:click="closeStorageBoxReveal">
            <span aria-hidden="true">&times;</span>
        </button>
        <div class="c-default-overlay-wrapper">
            <h2 class="c-heading-large">{{ translate('frontend.js.storage_box.heading') }}</h2>
            <storage-box v-on:requestQuote="requestQuote"></storage-box>
        </div>
    </div>
</template>
<script>
    import StorageBox from './storage-box';

    export default {
        name: 'storage-boxes-reveal',
        components: {
            'storage-box'   : StorageBox
        },
        mounted() {
            this.disableScroll();
        },
        beforeDestroy() {
            this.disableScroll();
        },
        methods: {
            /**
             * Close the storage box reveal
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            closeStorageBoxReveal() {
                this.$emit('closeStorageBoxReveal');
            },
            /**
             * Request a quote based on a storage box
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            requestQuote(storage_box) {
                this.$emit('openQuoteReveal', storage_box);
            },
            /**
             * Disables the scroll for the body when overlay is open
             *
             * @author Yonita van Oudheusden <yonita@click.nl>
             * @return void
             */
            disableScroll() {
                var $body = $('body');
                // Add class that will disable the scroll on the body 

                if($body.hasClass('u-disable-scroll')) {
                    $body.removeClass('u-disable-scroll');
                } else {
                    $body.addClass('u-disable-scroll');
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/global/storage-boxes-reveal.vue